import { NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule , provideClientHydration} from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { MenuComponent } from './components/menu/menu.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { ContentComponent } from './components/content/content.component';

import { HttpClient , HttpClientModule } from '@angular/common/http'; // Import HttpClientModule
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { AuthInterceptor } from './auth.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { DecimalPipe } from '@angular/common';

import { NgxSpinnerModule } from 'ngx-spinner';
import { GlobalErrorHandlerService } from './global-error-handler.service';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { SignUpComponent } from './pages/sign-up/sign-up.component';

import { TabService } from './tab.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from './MultiTranslateHttpLoader'; // Caminho para o loader customizado
import { SignUpConfirmationComponent } from './pages/sign-up-confirmation/sign-up-confirmation.component';
import { HealthCheckComponent } from './pages/health-check/health-check.component';
import { JwtModule } from '@auth0/angular-jwt';
import { AdminGuard } from './shared/guard/admin.guard';
import { environment } from '../environments/environment';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NewClientModalComponent } from './components/whatsapp/new-client-modal/new-client-modal.component';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { ChatWindowComponent } from './components/whatsapp/chat-window/chat-window.component';
import { FilaAtendimentoModalComponent } from './components/header/fila-atendimento-modal/fila-atendimento-modal.component';
import { 
  faWifi, 
  faUserGroup, 
  faUserGear, 
  faRightFromBracket,
  faCircle,
  faPowerOff
} from '@fortawesome/free-solid-svg-icons';
import { UnexpectedErrorComponent } from './pages/unexpected-error/unexpected-error.component';

// Função de fábrica para carregar os arquivos de tradução
export function HttpLoaderFactory(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, './assets/i18n/', '.json');
}
export function tokenGetter() {
  return localStorage.getItem('token');
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    MenuComponent,
    LoginComponent,
    ContentComponent,
    ResetPasswordComponent,
    ForgotPasswordComponent,
    SignUpComponent,
    SignUpConfirmationComponent,
    HealthCheckComponent,
    NewClientModalComponent,
    FilaAtendimentoModalComponent,
    UnexpectedErrorComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    ToastrModule.forRoot({
      positionClass:'toast-top-right'
    }),
    NgxSpinnerModule.forRoot(),
    BrowserAnimationsModule,
    MatTooltipModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        allowedDomains: [environment.apiUrl], // 🔥 Altere para o domínio da sua API
        //disallowedRoutes: ['sua-api.com/auth/login'] // 🔥 URLs que não precisam do token
      }
    }),
    NgbModule,
    PickerModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [DecimalPipe, 
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideClientHydration(),
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    TabService,
    AdminGuard],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      faWifi,
      faPowerOff,
      faUserGroup,
      faUserGear,
      faRightFromBracket,
      faCircle
    );
  }
}
